module.exports = __webpack_public_path__ + "static/media/4.f6fc9ad7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/4.jpg
// module id = 99
// module chunks = 0